module.exports = __webpack_public_path__ + "static/media/icon-dashboard-deal-registered.6d4a1e5c.svg";